import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getProduct, createProduct, updateProduct } from '../services/api'

export default function ProductForm() {
  const { id } = useParams()
  const navigate = useNavigate()
  const isEdit = !!id

  const [form, setForm] = useState({
    name: '', type: 'SERVICE', hsnSacCode: '', defaultRate: '', gstRate: '18', unit: 'NOS', description: '',
  })
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (isEdit) {
      getProduct(id).then((res) => {
        const p = res.data
        setForm({
          name: p.name, type: p.type, hsnSacCode: p.hsnSacCode || '', defaultRate: p.defaultRate?.toString() || '',
          gstRate: p.gstRate?.toString() || '18', unit: p.unit || 'NOS', description: p.description || '',
        })
      }).catch(() => navigate('/products'))
    }
  }, [id, isEdit, navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSaving(true)
    try {
      const payload = { ...form, defaultRate: Number(form.defaultRate), gstRate: Number(form.gstRate) }
      if (isEdit) {
        await updateProduct(id, payload)
      } else {
        await createProduct(payload)
      }
      navigate('/products')
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save')
    } finally {
      setSaving(false)
    }
  }

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value })

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h1 className="text-2xl font-semibold text-gray-900">{isEdit ? 'Edit Item' : 'New Product / Service'}</h1>

      <form onSubmit={handleSubmit} className="card space-y-4">
        {error && <div className="bg-red-50 text-red-700 px-4 py-3 rounded-lg text-sm">{error}</div>}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="label">Name *</label>
            <input className="input" value={form.name} onChange={set('name')} required />
          </div>
          <div>
            <label className="label">Type</label>
            <select className="select" value={form.type} onChange={set('type')}>
              <option value="PRODUCT">Product</option>
              <option value="SERVICE">Service</option>
            </select>
          </div>
          <div>
            <label className="label">{form.type === 'PRODUCT' ? 'HSN Code' : 'SAC Code'}</label>
            <input className="input font-mono" value={form.hsnSacCode} onChange={set('hsnSacCode')} placeholder={form.type === 'PRODUCT' ? '9021' : '998614'} />
          </div>
          <div>
            <label className="label">Rate (INR) *</label>
            <input type="number" min="0" step="0.01" className="input" value={form.defaultRate} onChange={set('defaultRate')} required />
          </div>
          <div>
            <label className="label">GST Rate</label>
            <select className="select" value={form.gstRate} onChange={set('gstRate')}>
              <option value="0">0%</option>
              <option value="5">5%</option>
              <option value="12">12%</option>
              <option value="18">18%</option>
              <option value="28">28%</option>
            </select>
          </div>
          <div>
            <label className="label">Unit</label>
            <select className="select" value={form.unit} onChange={set('unit')}>
              <option value="NOS">NOS (Numbers)</option>
              <option value="HRS">HRS (Hours)</option>
              <option value="PCS">PCS (Pieces)</option>
              <option value="SET">SET</option>
            </select>
          </div>
        </div>
        <div>
          <label className="label">Description</label>
          <textarea className="input" rows={2} value={form.description} onChange={set('description')} />
        </div>

        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={() => navigate(-1)} className="btn-secondary">Cancel</button>
          <button type="submit" disabled={saving} className="btn-primary">{saving ? 'Saving...' : isEdit ? 'Update' : 'Create'}</button>
        </div>
      </form>
    </div>
  )
}
